import { Component } from 'react';
import styled, { CSSProperties } from 'styled-components';
import { Tooltip as Tippy, TooltipProps } from 'umang-react-tippy';
import { PopoverDisplay } from './PopoverDisplay/PopoverDisplay';

interface Props {
  children?: React.ReactNode;
  content?: React.ReactNode;
  preferRight?: boolean;
  triggerOnClick?: boolean;
  tooltip?: boolean;
  light?: boolean;
  arrow?: boolean;
  style?: CSSProperties;
}

export class Popover extends Component<Props & TooltipProps> {
  state = {
    fullyMounted: false,
  };

  notifyMount = (node: Node | null) => {
    if (node) {
      this.setState({ fullyMounted: true });
    }
  };

  render() {
    const {
      preferRight,
      content,
      children,
      triggerOnClick,
      tooltip,
      light,
      position,
      trigger,
      arrow,
      ...restProps
    } = this.props;

    return (
      <>
        <Tippy
          disabled={!this.state.fullyMounted}
          interactive={!tooltip}
          delay={0}
          hideDelay={0}
          interactiveBorder={16}
          trigger={trigger || (triggerOnClick ? 'click' : 'mouseenter')}
          html={
            <PopoverDisplay light={light} tooltip={tooltip} arrow={arrow}>
              {content}
            </PopoverDisplay>
          }
          style={{ display: 'flex', flex: '0 0 auto' }}
          position={position || (preferRight ? 'bottom-end' : 'bottom-start')}
          useContext={true}
          {...restProps}
        >
          {children}
        </Tippy>

        {!this.state.fullyMounted && <Hidden ref={this.notifyMount} />}
      </>
    );
  }
}

export const Hidden = styled.span`
  display: none;
`;
